import { useState, useEffect } from "react";
import { getTechnician, postTechnician, putTechnician, deleteTechnician } from './Technician.service';
import GridComponent from '../../../component/grid/GridComponent.component';
import { Title } from '../../../component/title/Title';
import Technician from './interfaces/Technician';
import Table from '../../../component/table/Table.component';
import { INITIAL_VALUES } from './utils/INITIAL_VALUES';
import { HEAD_CELL } from './utils/HEAD_CELL';
import { Action, ACTION_DELETE, ACTION_EDIT } from "../../../component/table/interfaces/TableInterface";
import Modal from '../../../component/modal/Modal.component';
import Form from './form/Form.component';
import ButtonFormFull from '../../../component/buttton/ButtonFormFull.component';
import useModal from "../../../hooks/useModal";
import { useSnackbar } from "../../../context/Snackbar";
import ModalDelete from '../../../component/modal/ModalDelete.component';
import Brightness1Icon from '@material-ui/icons/Brightness1';

export default function TechnicianComponent() {

    const { setSnackbar } = useSnackbar();
    const [open, addModal] = useModal();
    const [technicians, setTechnicians] = useState<Technician[]>([]);
    const [technician, setTechnician] = useState<Technician>(INITIAL_VALUES);
    const [request, setRequest] = useState<boolean>(true);
    const [submit, setSubmit] = useState<boolean>(false);

    useEffect(() => {
        getTechnician().then((res) => {
            setTechnicians(res.data);
        }).catch((error) => {
            console.log('error', error)
        }).finally(() => {
            setRequest(false);
        });
    }, [request]);


    const registerTechnician = async (technician: Technician) => {
        setSubmit(true);
        if (technician._id) {
            technician.latitude = technician.location ? Number(technician.location.coordinates[0] || 0) : 0;
            technician.longitude = technician.location ? Number(technician.location.coordinates[1] || 0) : 0;
        }
        delete technician.location;
        try {
            await (technician._id ? putTechnician(technician) : postTechnician(technician));
            setSnackbar({ msg: `Profissional foi ${technician._id ? 'atualizado' : 'cadastrado'} com sucesso!`, type: 'success' });
            addModal(false);
            setRequest(true);
        } catch (error) {
            console.log('Erro ao submeter grupo!', error);
            setSnackbar({ msg: `Erro ao ${technician._id ? 'atualizar' : 'cadastrar'} profissional!`, type: 'error' });
        }
        setSubmit(false);
    }

    const handleClickAction = (action: Action, technician: Technician) => {
        setTechnician(technician);
        if (action === ACTION_EDIT) {
            return addModal(true);
        }
        if (action === ACTION_DELETE) {
            return addModal(technician._id);
        }
    };

    const handleClickDelete = async () => {
        setSubmit(true);
        await deleteTechnician(String(open)).then(res => {
            setSnackbar({ msg: "Profissional excluído com sucesso!", type: 'success' });
            setRequest(true);
        }).catch(error => {
            console.log('Erro ao excluir Profissional!', error);
            setSnackbar({ msg: "Erro ao excluir profissional!", type: 'error' });
        }).finally(function () {
            addModal(undefined);
            setSubmit(false);
        });
    };

    const setModalAddGroup = (value: string | boolean | undefined) => {
        setTechnician(INITIAL_VALUES);
        addModal(value);
    }

    return (
        <>
            <GridComponent justify="space-between">
                <Title>PROFISSIONAIS</Title>
                <Modal title="Cadastrar profissional" open={open === true} handleClick={() => setModalAddGroup(!open)} >
                    <Form initialValues={technician} handleSubmitForm={registerTechnician} >
                        <ButtonFormFull disabled={submit} onClick={() => addModal(false)} />
                    </Form>
                </Modal>
            </GridComponent>
            <ModalDelete open={!!open && open !== true} handleClick={() => addModal(undefined)} onClickSubmit={handleClickDelete} title="Confirma a exclusão desse profissional?" disabled={submit} />
            <br />
            <br />
            <Table
                request={request}
                data={technicians}
                size={technicians.length}
                headCells={HEAD_CELL}
                noActionView
                compare={(value: any, valueB: any, index: number) => {
                    return index === 2 ? <Brightness1Icon fontSize="small" style={{ color: value.status === 0 ? 'red' : '#008000' }} /> : valueB
                }}
                handleClickAction={handleClickAction}
            />

        </>
    );
}
